import React from 'react';
import { Tabs, TabList, Tab } from '@mui/joy';

interface MeetingsTabsProps {
  tab: number;
  onTabChange: (event: React.SyntheticEvent | null, value: number | string | null) => void;
}

const MeetingsTabs: React.FC<MeetingsTabsProps> = ({ tab, onTabChange }) => {
  return (
    <Tabs value={tab} onChange={onTabChange} aria-label="Meetings tabs" sx={{ mb: 4 }}>
      <TabList>
        <Tab value={0}>Upcoming</Tab>
        <Tab value={1}>Past</Tab>
      </TabList>
    </Tabs>
  );
};

export default MeetingsTabs; 